/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_Office_PcInputs */

const en_pc_cmp_r_office_pc = /** @type {(inputs: Pc_Cmp_R_Office_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Word export without layout fidelity. Office to PDF is next on the roadmap`)
};

const zh_pc_cmp_r_office_pc = /** @type {(inputs: Pc_Cmp_R_Office_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可导出 Word 但不保留版式，Office 转 PDF 是路线图下一项`)
};

/**
* | output |
* | --- |
* | "Word export without layout fidelity. Office to PDF is next on the roadmap" |
*
* @param {Pc_Cmp_R_Office_PcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_office_pc = /** @type {((inputs?: Pc_Cmp_R_Office_PcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_Office_PcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_office_pc(inputs)
	return zh_pc_cmp_r_office_pc(inputs)
});
export { pc_cmp_r_office_pc as "pc.cmp.r.office.pc" }